<template>
  <div id="app"> 
    <!-- 主应用的menu，所有子应用都要使用 -->
    <!-- <el-header style="padding: 0; margin-bottom: 26px">
      <OEMHeader></OEMHeader>
    </el-header> -->

    <!-- 承接主应用的page -->
    <router-view />

    <!-- 承接子应用的容器 -->
    <!-- <div id="container"></div> -->
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
html, body { 
  height: 100%
}
* { 
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
